import Service from '../service/Service';
const service = new Service();
var countimg = 0;
var countpdf = 0;
var img_flag = false;
var pdf_flag = false;
var file_array = [];
var commentDocUrl = "[]";
var isReply = false;

export function filterLink(text) {
    var newstring = "";
    var mainstring = text;
    if(mainstring){
      var matchedUrls = mainstring.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
    }
    else {
        return text;
    }
    if (matchedUrls) {
        for (var j = 0; j < matchedUrls.length; j++) {
            if (matchedUrls[j].match("^www.firstcry.com") || matchedUrls[j].match("^parenting.firstcry.com") || matchedUrls[j].match("^www.firstcry.ae") || matchedUrls[j].match("^parenting.firstcry.ae")) {
                newstring = mainstring.replace(matchedUrls[j], '<a rel="noopener" target="_blank" href="//' + matchedUrls[j] + '" class="discDescrpLink">' + matchedUrls[j] + '</a>');
                mainstring = newstring;
            }
            else if (matchedUrls[j].match("www.firstcry.com") || matchedUrls[j].match("parenting.firstcry.com") || matchedUrls[j].match("www.firstcry.ae") || matchedUrls[j].match("parenting.firstcry.ae")) {
                newstring = mainstring.replace(matchedUrls[j], '<a rel="noopener" target="_blank" href="' + matchedUrls[j] + '" class="discDescrpLink">' + matchedUrls[j] + '</a>');
                mainstring = newstring;
            }
        }
        return mainstring;
    } else {
        return text;
    }
}

export function setWidth() {
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('write-comment')[0]) {
            document.getElementsByClassName('write-comment')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('participate-popup')[0]) {
            document.getElementsByClassName('participate-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('comment-popup')[0]) {
            document.getElementsByClassName('comment-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
        if (document.getElementsByClassName('comment-popup')[0]) {
            document.getElementsByClassName('comment-popup')[0].style.width = document.getElementsByClassName('main-container')[0].offsetWidth + "px";
        }
    }
}

export function loadSliders() {
    let slider = document.querySelectorAll(".slider");
    for (let i = 0; i < slider.length; i++) {
        let margin = 10;
        let extraWidth = 10;
        let cnt = slider[i].getAttribute("data-count");
        if (slider[i].getElementsByClassName('slide')[0]) {
            let sliderulwidth = cnt * slider[i].getElementsByClassName('slide')[0].offsetWidth;
            let marginbetweenimages = (cnt - 1) * margin;
            slider[i].style.width = (sliderulwidth + marginbetweenimages + extraWidth) + "px";
        }
        if (slider[i].offsetWidth < document.getElementsByClassName("sub-container")[0].offsetWidth) {
            if (slider[i].nextSibling) {
                slider[i].nextSibling.remove();
            }
        }
    }
}

export function loadReadMore() {
   
    let readmoreAry = document.getElementsByClassName('readmore_popup');
    for (let i = 0; i < readmoreAry.length; i++) {
        let maxHeight = 60;
        let dataId = readmoreAry[i].getAttribute('data-id');
        let divHeight = document.getElementById(dataId).offsetHeight;
        if (divHeight > maxHeight) {
            document.getElementById(dataId).style.height = maxHeight + 'px';
            readmoreAry[i].style.display = "inline-block";
        }
    }
}

export function readMoreClick(event, dataId) {
    if (event.target.innerHTML == "Read More") {
        event.target.innerHTML = "Read Less";
        document.getElementById(dataId).style.height = 'auto';
    } else {
        event.target.innerHTML = "Read More";
        let maxHeight = 60;
        document.getElementById(dataId).style.height = maxHeight + 'px';
    }
}

export function checkCheckbox(pt) {
    var ele;
    if (pt == 0) {
        ele = document.getElementsByClassName('participate-overlay')[0].getElementsByClassName('isAnonymous')[0];
    } else {
        ele = document.getElementsByClassName('comment-overlay')[0].getElementsByClassName('isAnonymous')[0];
    }
    if (ele.classList.contains('isChecked')) {
        ele.classList.remove('isChecked');
        ele.setAttribute('data-icon-font', 'z');
    } else {
        ele.classList.add('isChecked');
        ele.setAttribute('data-icon-font', 'A');
    }
}

export function followDiscussion(dId, dUserId, gId, cId, status, eleRef) {
    if (global.ftk != '') {
        service.showLoader();
        var postData = {
            "discussionId": dId,
            "status": status,
            "discussionUserId": dUserId,
            "userName": global.userAry['userName'],
            "groupId": gId,
            "categoryId": cId
        }
        var url = global.api_ci_url + "Discussions/followdiscussion";
        service.postServiceCall(url, postData).then((json) => {
            eleRef.reloadData();
            // service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function likeComment(dId, dUserId, gId, cId, dTitle, dUrl, pComment, cmtId, cUserId, cmt, status, eleRef) {
    if (global.ftk != '') {
        service.showLoader();
        var pAry = {};
        var postType = 0;
        var commentId = cmtId;
        var commentUserId = cUserId;
        var comment = cmt;
        var replyId = '0';
        var replyUserId = '';

        if (pComment != '') {
            pAry = JSON.parse(pComment);
            postType = 1;
            commentId = pAry.parentId;
            commentUserId = pAry.parentUserId;
            replyId = cmtId;
            replyUserId = cUserId;
        }
        var postData = {
            "discussionId": dId,
            "status": status,
            "discussionUserId": dUserId,
            "userName": global.userAry['userName'],
            "groupId": gId,
            "categoryId": cId,
            "discussionTitle": dTitle,
            "discussionImageUrl": dUrl,
            "commentId": commentId,
            "commentUserId": commentUserId,
            "comment": comment,
            "replyId": replyId,
            "replyUserId": replyUserId,
            "postType": postType
        }
        
        var url = global.api_ci_url + "Discussions/likeaction";
        service.postServiceCall(url, postData).then((json) => {
            eleRef.reloadData();
            // service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function showAbuse(cmtId) {
    let ary = document.getElementsByClassName('abuse-tooltip');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    document.getElementById('comment_' + cmtId).getElementsByClassName('abuse-tooltip')[0].style.display = 'block';
}

export function reportAbuse(cmtId, gId, cId) {
    if (global.ftk != '') {
        service.showLoader();
        var postData = {
            "commentId": cmtId,
            "groupId": gId,
            "categoryId": cId
        }
        var url = global.api_ci_url + "Discussions/reportabuse";
        service.postServiceCall(url, postData).then((json) => {
            if (parseInt(json['msg']) == 1) {
                document.getElementById('comment_' + cmtId).getElementsByClassName('icon3dot')[0].classList.add('is-active')
                document.getElementById('comment_' + cmtId).getElementsByClassName('abuse-tooltip')[0].style.display = 'none';
                document.getElementById('comment_' + cmtId).getElementsByClassName('abuse-tooltip')[0].innerHTML = 'Already Reported as Abuse';
                document.getElementById('comment_' + cmtId).getElementsByClassName('abuse-tooltip')[0].removeAttribute("onClick");
            } else {
                service.showAlert("Fail");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function followersList(dId, fCnt) {
    service.showLoader();
    var postData = {
        "discussionId": dId,
        "pageno": 1,
        "pagesize": fCnt
    }
    var url = global.api_ci_url + "Discussions/getfollowusers";

    service.postServiceCall(url, postData).then((json) => {
        if (json['msg'] == "1") {
            let data = json['result'];
            if (data.length > 0) {
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'FOLLOWERS';
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }
        } else {
            service.closeUserListPopup();
            service.showAlert("Fail");
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}

export function participantList(dId, pCnt) {
    service.showLoader();
    var postData = {
        "discussionId": dId,
        "pageno": 1,
        "pagesize": pCnt
    }
    var url = global.api_ci_url + "Discussions/getparticipantusers";
    service.postServiceCall(url, postData).then((json) => {
        if (json['msg'] == "1") {
            let data = json['result'];
            if (data.length > 0) {
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'PARTICIPANTS';
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }
        } else {
            service.closeUserListPopup();
            service.showAlert("Fail");
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}

export function getCmtLikeUsers(rId, uId, pt, lCnt) {

    service.showLoader();
    var postData = {
        "recordId": rId,
        "commentUserId": uId,
        "postType": pt,
        "pageno": 1,
        "pagesize": lCnt
    }
    var url = global.api_ci_url + "Discussions/getlikeuser";
    service.postServiceCall(url, postData).then((json) => {
        if (json['msg'] == "1") {
            let data = json['result'];
            if (data.length > 0) {
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }
        } else {
            service.closeUserListPopup();
            service.showAlert("Fail");
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}

export function shareOn(id) {
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
}

export function shareArticle(dId, shareoption, articleurl) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function openParticipatePopup(dId, dTitle, dDesc, gId, cId, dUrl) {
    if (global.ftk != '') {
        document.getElementById('DissussionTitle').innerHTML = dTitle;
        document.getElementById('DissussionContent').innerHTML = dDesc;
        document.getElementById('post_dId').value = dId;
        document.getElementById('post_gId').value = gId;
        document.getElementById('post_cId').value = cId;
        document.getElementById('post_dUrl').value = dUrl;
        document.getElementsByClassName('participate-overlay')[0].style.display = 'block';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        let top = document.getElementsByClassName('comment-reply-box')[0].offsetTop + 260;
        document.getElementsByClassName('participate-overlay')[0].getElementsByClassName('post_comment')[0].style.top = top + 'px';
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function openCommentPopup(cmtId, cmt, cUserId, cUserName, cIsAno, pComment, dId, gId, cId, dTitle, dUrl) {
    if (global.ftk != '') {
        isReply = true;
        var pAry = {};
        var commentId = cmtId;
        var parentUserId = cUserId;
        var parentUserName = cUserName;
        var parentIsAnonymus = cIsAno;
        var replyId = 0;

        if (pComment != '') {
            pAry = JSON.parse(pComment);
            commentId = pAry.parentId;
            replyId = cmtId;
        }
        document.getElementById('DissussionTitle').innerHTML = dTitle;
        document.getElementById('post_commentId').value = commentId;
        document.getElementById('post_parentUserId').value = parentUserId;
        document.getElementById('post_parentUserName').value = parentUserName;
        document.getElementById('post_parentIsAnonymus').value = parentIsAnonymus;
        document.getElementById('post_replyId').value = replyId;
        document.getElementById('post_dId').value = dId;
        document.getElementById('post_gId').value = gId;
        document.getElementById('post_cId').value = cId;
        document.getElementById('post_dUrl').value = dUrl;
        document.getElementById('ParentCommentContent').innerHTML = cmt;
        document.getElementsByClassName('comment-overlay')[0].style.display = 'block';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        let top = document.getElementsByClassName('comment-reply-box')[0].offsetTop + 260;
        document.getElementsByClassName('comment-overlay')[0].getElementsByClassName('post_comment')[0].style.top = top + 'px';
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function closeCommentPopup(event) {
    if (event.target.classList.contains('participate-overlay') || event.target.classList.contains('comment-overlay') || event.target.classList.contains('closeButton')) {
        clearCommentPopupData();
    }
}

function clearCommentPopupData() {
    if (document.getElementsByClassName('participate-overlay')[0]) {
        document.getElementsByClassName('participate-overlay')[0].style.display = 'none';
    }
    if (document.getElementsByClassName('comment-overlay')[0]) {
        document.getElementsByClassName('comment-overlay')[0].style.display = 'none';
    }
    document.getElementById('DissussionTitle').innerHTML = "";
    document.getElementById('DissussionContent').innerHTML = "";
    document.getElementById('post_commentId').value = "";
    document.getElementById('post_parentUserId').value = "";
    document.getElementById('post_parentUserName').value = "";
    document.getElementById('post_parentIsAnonymus').value = "";
    document.getElementById('post_replyId').value = "";
    document.getElementById('post_dId').value = "";
    document.getElementById('post_gId').value = "";
    document.getElementById('post_cId').value = "";
    document.getElementById('post_dUrl').value = "";
    if (document.getElementById('ParentCommentContent')) {
        document.getElementById('ParentCommentContent').innerHTML = "";
    }
    if (document.getElementById('writeComment')) {
        document.getElementById('writeComment').value = "";
    }
    if (document.getElementById('postComment')) {
        document.getElementById('postComment').value = "";
    }
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    countimg = 0;
    countpdf = 0;
    img_flag = false;
    pdf_flag = false;
    file_array = [];
    commentDocUrl = "[]";
    var fileEle = document.getElementsByClassName('uploaded-files-list')[0];
    fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    isReply = false;
}

export function cmtFileUpload() {
    service.showLoader();
    var mainClass = 'participate-overlay';
    if (isReply) {
        mainClass = 'comment-overlay';
    }
    var fileObj = document.getElementById("fileupload").files[0];
    var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
    var file_name = "";
    var apiurl = "";
    if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png") && fileObj.size < 2097152) {
        file_name = fname + ".jpg";
        img_flag = true;
        countimg++;
        apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
    } else if (fileObj.type == "application/pdf" && fileObj.size < 2097152) {
        file_name = fname + ".pdf";
        pdf_flag = true;
        countpdf++;
        apiurl = global.api_ci_url + "Parenting/uploadFilesToCommunity";
    } else {
        countimg = 0;
        countpdf = 0;
        apiurl = "";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "Only JPEG, JPG, PNG and PDF files allowed of less than 2 MB";
        return;
    }
    if ((img_flag && countimg == 1) || (pdf_flag && countpdf == 1)) {
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
        service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
            if (json["result"] == 'success') {
                file_array.push({
                    "url": json["image_url"],
                    "height": 10,
                    "width": 10
                });
                commentDocUrl = JSON.stringify(file_array);
                var fileEle = document.getElementsByClassName(mainClass)[0].getElementsByClassName('uploaded-files-list')[0];
                if (fileObj.type == "application/pdf") {
                    fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "list-item";
                    fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                } else {
                    fileEle.getElementsByClassName('cmt-image')[0].style.display = "list-item";
                    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                }
            } else {
                service.showAlert("Fail");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "Only 1 image can be uploaded & only 1 pdf can be uploaded";
        service.hideLoader();
        return;
    }
}

export function cmtFileDelete(type) {
    for (var i = 0; i < file_array.length; i++) {
        if (type == 'pdf') {
            if (file_array[i]['url'].split('.').pop() == 'pdf') {
                file_array.splice(i, 1);
            }
        } else {
            if (file_array[i]['url'].split('.').pop() != 'pdf') {
                file_array.splice(i, 1);
            }
        }
    }
    commentDocUrl = JSON.stringify(file_array);
    var fileEle = document.getElementsByClassName('uploaded-files-list')[0];
    if (type == "pdf") {
        countpdf--;
        pdf_flag = false;
        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    } else {
        countimg--;
        img_flag = false;
        fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    }
}

export function addComment(pt, eleRef) {
    if (global.ftk != '') {
        var comment = document.getElementById('writeComment').value.trim();
        var mainClass = 'participate-overlay';
        if (pt == 1) {
            comment = document.getElementById('postComment').value.trim();
            mainClass = 'comment-overlay';
        }
        if (comment != "") {
            document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
            document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
            service.showLoader();
            var commentId = "0";
            var replyId = "0";
            var parentText = "";
            var parentUserId = "";
            var parentUserName = "";
            var parentIsAnonymus = 0;
            var isAnonymus = 0;
            var comment = document.getElementById('writeComment').value.trim();
            var ele;
            if (pt == 1) {

                commentId = document.getElementById('post_commentId').value;
                parentText = document.getElementById('ParentCommentContent').innerHTML;
                parentUserId = document.getElementById('post_parentUserId').value;
                parentUserName = document.getElementById('post_parentUserName').value;
                parentIsAnonymus = parseInt(document.getElementById('post_parentIsAnonymus').value);
                replyId = document.getElementById('post_replyId').value;
                comment = document.getElementById('postComment').value.trim();
                ele = document.getElementsByClassName('comment-overlay')[0].getElementsByClassName('isAnonymous')[0];
            } else {
                ele = document.getElementsByClassName('participate-overlay')[0].getElementsByClassName('isAnonymous')[0];
            }
            if (ele.classList.contains('isChecked')) {
                isAnonymus = 1;
            }
            var postData = {
                "postType": pt,
                "comment": comment,
                "isAnonymus": isAnonymus,
                "discussionId": document.getElementById('post_dId').value,
                "discussionTitle": document.getElementById('DissussionTitle').innerHTML,
                "discussionImageUrl": document.getElementById('post_dUrl').value,
                "replyId": replyId,
                "commentId": commentId,
                "parentText": parentText,
                "parentUserId": parentUserId,
                "parentUserName": parentUserName,
                "parentIsAnonymus": parentIsAnonymus,
                "docUrls": commentDocUrl,
                "coverFlag": 0,
                "userName": global.userAry['userName'],
                "groupId": document.getElementById('post_gId').value,
                "categoryId": document.getElementById('post_cId').value
            }
            
            var url = global.api_ci_url + "Discussions/addcomment";
            service.postServiceCall(url, postData).then((json) => {
                if(json.isModerate == 0){
                    if (pt == 1) {
                            document.getElementById("disModMsg").innerHTML='Reply Added Successfully';
                            document.getElementsByClassName('discussionmoderation-overlay')[0].style.display = 'block';
                    }
                    else{
                        document.getElementById("disModMsg").innerHTML='Comment Added Successfully';
                        document.getElementsByClassName('discussionmoderation-overlay')[0].style.display = 'block';
                    }
                    clearCommentPopupData();
                    //eleRef.reloadData();

                }else{
                    if (pt == 1) {
                        document.getElementById("disModMsg").innerHTML='Thanks for reply.your reply is under review,you can view status in My account->My Topic';
                        document.getElementsByClassName('discussionmoderation-overlay')[0].style.display = 'block';
                        
                    }
                    else{
                        document.getElementById("disModMsg").innerHTML='Thanks for comment.your comment is under review,you can view status in My account->My Topic';
                        document.getElementsByClassName('discussionmoderation-overlay')[0].style.display = 'block';
                    }
                    clearCommentPopupData();
                    //eleRef.reloadData();
                }

                // clearCommentPopupData();
                // eleRef.reloadData();
		         service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
            document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "Comment box cannot be empty";
            if (document.getElementById('postComment')) {
                document.getElementById('postComment').value = "";
            }
            if (document.getElementById('writeComment')) {
                document.getElementById('writeComment').value = "";
            }
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function domClick(event) {

    if (!event.target.classList.contains('abuse-tooltip') && !event.target.classList.contains('report_abuse') && !event.target.classList.contains('icon3dot')) {
        let ary = document.getElementsByClassName('abuse-tooltip');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
    }
    if (!event.target.classList.contains('share-icon') && !event.target.classList.contains('share-text') && !event.target.classList.contains('share-container')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
    if (event.target.classList.contains('likelist-follow')) {
        service.followUserAction(1, event.target.getAttribute('data-id'));
    }
    if (event.target.classList.contains('likelist-unfollow')) {
        service.followUserAction(0, event.target.getAttribute('data-id'));
    }
}

export function only_title(title){
    // if(title){
    //  return (title).split(">")[1].split("<")[0];
    // }
    
    return title;
}



// WEBPACK FOOTER //
// src/shared/discussions/Actions.js